import { useContext } from "react";
import { Box, LinearProgress, Grid, Paper, Stack, SvgIcon, Typography } from '@mui/material'
import { DataContext } from '../../contexts/data/dataContext'
import custom from '../../styles/mui/szVariables.json'

export default function UsageSummary({ title, description, rowData }: any) {
    const data = useContext(DataContext)
    const border = custom.border
    if((rowData ||[]).every((row:any)=>!row?.percent)){
        return null;
    }
    
    return (
        <Box width="100%" >
            <Box display="flex"
                pt={custom.spacing.sm}
                pb={custom.spacing.xxs}>
                <Typography component={"h3"} 
                    id="usageSummaryTitle" 
                    variant="szHeading.Bold.xSmall">
                        {title}
                </Typography>
            </Box>
            <Paper elevation={0} sx={{ 
                borderRadius: custom.corners4, 
                border,  
                width: '100%',
                px: custom.spacing.sm,
                pt: custom.spacing.xxs,
                boxSizing: 'border-box' }} >
                {rowData?.map((row: any, idx: number)=>(
                    <Grid item key={idx} 
                        py={custom.spacing.xs}
                        sx ={{ borderBottom: idx===(rowData.length-1)?'none': border }} >
                        <Stack alignItems="start" 
                            direction="row" 
                            justifyContent="flex-center" 
                            >
                            <Stack alignItems="center" direction="row" 
                                justifyContent="center"
                                alignContent={"center"}>
                                <SvgIcon viewBox="0 0 24 24"
                                    sx={{ 
                                        color: `${row?.color}`
                                    }}> 
                                    {row?.iconPath} 
                                </SvgIcon>
                                <Typography
                                    pl={custom.spacing.xxs}
                                    pb={custom.spacing.xxxs} 
                                    id={(title+row?.name)
                                        .replaceAll(' ','')} 
                                    variant="szBody.Regular.Medium" > 
                                    {row?.name}
                                </Typography>
                            </Stack>
                            <Stack alignItems="center" direction="row" 
                                justifyContent="flex-end" 
                                sx={{ ml: 'auto' }}>
                                <Box 
                                    mr={custom.spacing.xxs}
                                    width={{
                                        xs: "40px",
                                        sm: "80px",
                                        md: data?.rightPanel?"50px":"150px", 
                                        lg: "200px"}}
                                        id={(title+row?.name+'ProgressBar')
                                                .replaceAll(' ','')}>
                                    <LinearProgress variant="determinate" 
                                        value={row?.percent} 
                                        color={row?.id}
                                        sx={{
                                            height: 10,
                                            borderRadius: custom.corners1,
                                            backgroundColor: 
                                                'sz.colors.surfaceWellSmall'
                                        }}/>
                                </Box>
                                <Box width="90px" display={"flex"} 
                                    justifyContent={"flex-end"}>
                                    <Typography  
                                        variant="szBody.Regular.Medium" 
                                        sx={{ color: 'text.secondary' }}
                                        id={(title+row?.name+'Value')
                                                .replaceAll(' ','')}> 
                                        {row.kwh} 
                                        <Typography 
                                            variant="szBody.Regular.xxSmall"> 
                                            kWh
                                        </Typography>
                                    </Typography>
                                </Box>
                                <Box width="40px" 
                                    pl={custom.spacing.xxs} 
                                    display={"flex"} 
                                    justifyContent={"flex-end"}> 
                                    <Typography variant="szBody.Bold.Medium" 
                                        id={(title+row?.name+'Percent')
                                                .replaceAll(' ','')}> 
                                        {row?.percent}%
                                    </Typography>
                                </Box>
                            </Stack>
                        </Stack>
                    </Grid>
                ))}
            </Paper>
            <Grid container direction={"row"}
                justifyContent={"center"}
                py={custom.spacing.xxs}
                px={custom.spacing.sm}
                id='usageSummaryDescription'>
                {(description?.split('<br>') || [])
                    .map((desc:string, index: number)=>(
                    <Grid item xs={12} key={index}>    
                        <Typography key={index} 
                            sx={{ color: 'text.secondary' }}  
                            variant="szBody.Regular.Small">
                                {desc}
                        </Typography>
                    </Grid>
                ))}
            </Grid>
        </Box>
    )
}